import { forwardRef } from 'react'
import { IconProps } from 'almanac-ui/icons/Types'

export const Impact = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 32 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      fill="none"
      viewBox="0 0 32 32"
      ref={forwardedRef}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.89228 4.86665C5.79848 4.09235 6.40288 3.41033 7.18284 3.41033H24.0914C24.879 3.41033 25.4857 4.10514 25.3795 4.88557L22.5085 25.989C22.4209 26.6333 21.8706 27.1138 21.2204 27.1138H9.7391C9.08159 27.1138 8.5276 26.6229 8.44853 25.9701L5.89228 4.86665Z"
        fill="#FB6434"
        stroke="#2B2F38"
        strokeWidth="1.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3249 7.55492C22.7115 7.55492 23.0249 7.24152 23.0249 6.85492C23.0249 6.46833 22.7115 6.15492 22.3249 6.15492L20.7701 6.15492C20.3835 6.15492 20.0701 6.46833 20.0701 6.85492C20.0701 7.24152 20.3835 7.55492 20.7701 7.55492L22.3249 7.55492ZM9.46497 7.55506C9.85157 7.55506 10.165 7.24166 10.165 6.85506C10.165 6.46846 9.85157 6.15506 9.46497 6.15506L8.98299 6.15506C8.59639 6.15506 8.28299 6.46846 8.28299 6.85506C8.28299 7.24166 8.59639 7.55506 8.98299 7.55506L9.46497 7.55506ZM19.3416 6.85492C19.3416 7.24152 19.0282 7.55492 18.6416 7.55492L17.0868 7.55492C16.7002 7.55492 16.3868 7.24152 16.3868 6.85492C16.3868 6.46833 16.7002 6.15492 17.0868 6.15492L18.6416 6.15492C19.0282 6.15492 19.3416 6.46833 19.3416 6.85492ZM14.9941 7.55478C15.3807 7.55478 15.6941 7.24138 15.6941 6.85478C15.6941 6.46819 15.3807 6.15478 14.9941 6.15478L13.4393 6.15478C13.0527 6.15478 12.7393 6.46819 12.7393 6.85478C12.7393 7.24138 13.0527 7.55478 13.4393 7.55478L14.9941 7.55478Z"
        fill="#2B2F38"
      />
      <mask
        id="mask0_7090_324"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="22"
        height="26"
      >
        <path
          d="M5.89228 4.86665C5.79848 4.09235 6.40288 3.41033 7.18284 3.41033H24.0914C24.879 3.41033 25.4857 4.10514 25.3795 4.88557L22.5085 25.989C22.4209 26.6333 21.8706 27.1138 21.2204 27.1138H9.7391C9.08159 27.1138 8.5276 26.6229 8.44853 25.9701L5.89228 4.86665Z"
          fill="#FFDB59"
          stroke="#2B2F38"
          strokeWidth="1.4"
        />
      </mask>
      <g mask="url(#mask0_7090_324)">
        <path
          d="M21.3479 9.59325C18.3912 11.6301 13.7155 13.4984 11.3539 9.33513C12.5277 13.2091 11.5641 17.4679 5.82897 17.1388C8.10046 18.5772 11.2179 21.8434 6.24116 25.1451C11.0154 27.2944 18.4617 29.7836 25.0687 23.5273C20.9897 18.7972 21.6007 18.8649 25.8754 16.453C20.2348 16.0118 20.0045 13.0569 21.3479 9.59325Z"
          fill="#F8B200"
          stroke="#2B2F38"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M10.7344 24.9043C11.6027 25.6606 13.5355 27.0192 15.9164 27.1312C18.1573 27.1312 20.1742 26.0668 20.7344 23.8539C22 22.5687 21.4062 18.2875 18.3125 16.0062C17.2188 19.1937 15.4688 18.975 14.25 16.6C14.75 18.7875 14.8125 21.8812 12 20.5687C14.9062 23.6312 13.8125 26.0687 10.7344 24.9043Z"
        fill="#FFDB59"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.2922 16L20.9989 28.6741L23.827 25.7217L26.635 29.2722L29.7635 26.4197L26.858 23.1653L30.2006 20.6226L18.2922 16Z"
        fill="white"
        stroke="#2B2F38"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
})

export default Impact
